import { ELanguage } from '@/interfaces/common';
import { action, configure, observable, computed } from 'mobx';
import history from 'lib/history';
import { IProfile, IProfileResponse, EStatus, IConfirmContract } from 'interfaces/user';
import * as ajax from 'lib/axios';

configure({ enforceActions: 'observed' });

class UserStore {
  @observable
  isFirstLogin = false;

  @observable
  userProfile: IProfile = {
    companyName: '',
    merchantId: '',
    merchantName: '',
    address: '',
    phoneAreaCode: '',
    phoneNumber: '',
    email: '',
    username: '',
    createTime: -1,
    profilePhotoUrl: '',
    isFirstLogin: true,
    type: 'COMPANY',
    merchantList: [],
    showUserInfoFlag: false,
    contract: undefined,
    isOnline: true,
  };

  @observable
  loading = true;

  @observable currentMerchantId = '';

  welcomeEmail = '';

  getProfile = () => {
    return ajax.handle.get<IProfileResponse>('/profile');
  };

  changeLang = (language: ELanguage) => {
    return ajax.handle.post('/change-language', { language });
  };

  confirmContract = (data: IConfirmContract) => {
    return ajax.handle.post('/confirm-contract', data);
  };

  @action setMerchantId = (id: string | null) => (this.currentMerchantId = id ?? '');

  @action
  setUserProfile = (userData: IProfile) => {
    this.userProfile = userData;
  };

  @computed
  get merchantList() {
    const list = Array.from(this.userProfile.merchantList ?? []);
    list.sort((a, b) => {
      if (a.status === EStatus.DISABLED) {
        return 1;
      }
      return a.merchantName.localeCompare(b.merchantName);
    });
    return list;
  }

  @action authFailed = (e: any) => {
    console.log('error: ', e);
    history.push('/login');
  };

  @action
  setIsFirstLogin = (flag: boolean) => {
    this.isFirstLogin = flag;
  };

  @action
  setWelcomeEmail = (email: string) => {
    this.welcomeEmail = email;
  };

  @action
  updateLoadingStatus = (isLoading: boolean) => {
    this.loading = isLoading;
  };

  @action
  clearUserInfo = () => {
    this.userProfile = {
      companyName: '',
      merchantId: '',
      merchantName: '',
      address: '',
      phoneAreaCode: '',
      phoneNumber: '',
      email: '',
      username: '',
      createTime: -1,
      profilePhotoUrl: '',
      isFirstLogin: true,
      type: 'COMPANY',
      merchantList: [],
      showUserInfoFlag: false,
      isOnline: true,
    };
  };
}

export default new UserStore();
